import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../utils';
import { Button, Group } from 'react-aria-components';
export function DatePickerButton({ children, className }) {
    return (_jsx(Group, { children: _jsx(Button, { className: cn('p-1.5 hover:bg-gray-50 rounded-lg text-gray-700 focus:outline-indigo-400', className), children: children }) }));
}
